const sysdic = {
  state: {
    dicList: []
  },
  mutations: {
    SET_DIC: (state, dicList) => {
      state.dicList = dicList;
    }
  },
  actions: {
    SetDic({ commit }, dicList) {
      commit('SET_DIC', dicList);
    }
  }
};

export default sysdic;



// WEBPACK FOOTER //
// ./src/store/modules/sysdic.js